module.exports = __webpack_public_path__ + "img/bkash-education-promotion.63302511.jpg";